import React from 'react';
import { Popover } from 'antd';

export const PhoneHint = () =>
  (<p className="auth__form-label-right auth__form-label-right--disabled">{'(066) 123 45 67'}</p>)

export const PasswordHint = () => {
  const rules = (
    <div>
      <ul className="auth__form-password-rules">
        <li>8-14 символів</li>
        <li>букви латинського алфавіту (A-z)</li>
        <li>рядкові та заголовні букви</li>
        <li>цифри (0-9)</li>
      </ul>
    </div>
  );

  return (
    <Popover title="Пароль повинен містити"
             content={rules}
             trigger="hover" placement="rightBottom">

      <p className="auth__form-label-right">Вимоги до паролю</p>
    </Popover>
  );
}
